var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1550_1109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8461 0H1.15393C0.516602 0 0 0.516602 0 1.15393V14.8461C0 15.4834 0.516602 16 1.15393 16H14.8461C15.4834 16 16 15.4834 16 14.8461V1.15393C16 0.516602 15.4834 0 14.8461 0ZM5.67529 12.0938H3.72693V6.23206H5.67529V12.0938ZM4.70117 5.43164H4.68848C4.03467 5.43164 3.61182 4.98157 3.61182 4.41907C3.61182 3.84387 4.04761 3.40625 4.71411 3.40625C5.38062 3.40625 5.79077 3.84387 5.80347 4.41907C5.80347 4.98157 5.38062 5.43164 4.70117 5.43164ZM12.7007 12.0938H10.7526V8.95789C10.7526 8.1698 10.4705 7.63232 9.7655 7.63232C9.22729 7.63232 8.90674 7.99487 8.76587 8.34485C8.71436 8.47009 8.70178 8.64514 8.70178 8.82031V12.0938H6.75354C6.75354 12.0938 6.77905 6.78198 6.75354 6.23206H8.70178V7.06201C8.96069 6.6626 9.42395 6.09448 10.4576 6.09448C11.7395 6.09448 12.7007 6.93225 12.7007 8.73267V12.0938Z",
    fill: "#0D1116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1550_1109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8aa62b61e988ac2038fc87e480ddc968.svg";
export { ForwardRef as ReactComponent };